import React, { useState, useEffect, SetStateAction } from "react";
import {  ActiveFiltersStructure, ProductVariant, _ProductDetail } from "./Products";
import { redirect, useFetcher, useNavigate } from "react-router-dom";
import { getKind } from "./ProductDetailFormat";
import ActionCountdown from "./ActionCountdown";

  interface Parameter {
    id: number;
    type: string;
    name: string;
    image: string;
  }
  interface FilterNode {
    [type: string]: {
      [language: string]: {
        [size: string]: {
          [id: number]: {
            stock_amount: number;
            files: string | null;
            vat: number;
            price: number;
          };
        };
      };
    };
  }
  //const defaultFilterNode: FilterNode = {};
interface tooltips  {
    tooltipClass: string;
    tooltipSpan: boolean;
    tooltipAddToCartClass: string;
    tooltipAddToCartSpan: boolean;
    tooltipAddToCartFailedSpan: boolean;
}
// Dořešit načítání odkazu do href na kategorii z filtrů
// Ve vzorových datech chybí Velikost, Materiál, Silueta, Dašlí vlastnosti, Tagy.
interface ProductDetailLabelsProps {
    pDetailData: _ProductDetail
    handlerAddToCart: (id: number, itemCount: number, idVariant: number) => Promise<{status: boolean, message: string}>;
    handlerClose: () => void;
    handleParams: (event: any) => void;
    detailLabelsCategoryCallback : (categoryId : number) => void;
  }
const ProductDetailLabels: React.FC<ProductDetailLabelsProps> = ({ pDetailData, handlerAddToCart, handlerClose, handleParams, detailLabelsCategoryCallback }) => {

    const navigate = useNavigate();
    const isDigitalByFormat = getKind(pDetailData) === 'digital';

    const [selectedItemId,setSelectedItemId] = useState<number>(-1);
    const [showLanguage,setShowlanguage] = useState<boolean>(false);
    const [itemCount, setItemCount] = useState(1);
    const [limit, setLimit] = useState(1);

    const[price,setPrice] = useState(0);

    const [tooltipVisible, setTooltipVisible] = useState<tooltips>({
        tooltipClass: "",
        tooltipSpan: false,
        tooltipAddToCartClass: "",
        tooltipAddToCartSpan: false,
        tooltipAddToCartFailedSpan: false
    });
    const [failMessage, setFailMessage] = useState<string>("");



    const [filterTree, setFilterTree] = useState<FilterNode>({});

    const createFilterTree = (variants: ProductVariant[]): FilterNode => {
        const filterTree: FilterNode = {};
        variants.forEach((variant) => {
          const { type, language, size, id, stock_amount, files, vat, price } = variant;
        if(stock_amount!==0){
          if (!filterTree[type]) {
            filterTree[type] = {};
          }
      
          if (!filterTree[type][language]) {
            filterTree[type][language] = {};
          }
          if (size !== null) {

            if (!filterTree[type][language][size]) {
              filterTree[type][language][size] = {};
            }
            
            filterTree[type][language][size][id] = { stock_amount, files, vat, price };
            
          }else{
            
            if (!filterTree[type][language]["null"]) {
                //:()
                filterTree[type][language]["null"] = {};
              }
              
              filterTree[type][language]["null"][id] = { stock_amount, files, vat, price };
              
            }
        }});
    
      
   


        return filterTree;
      };

    const selectEvent = (index: any)=>{
        console.log(index);
    };
      
   

    const [variantType,setVariantType] = useState("");
    const [languageType,setLanguageType] = useState("");
    const handleChangeVariantsType = (event: any) => {
       
     
   /*
    checkboxLanguage.forEach((element) => {
      //element.checked = false
      console.log("checked", element);
    });
    */

    //setIdVariant(0);
    // console.log(uniqueItems, "FILTERED VARIANTS");
     console.log(event.target.id, "CHECK VARIANTS");
     //setVariantType(event.target.id);
     setVariantType(old=>event.target.id);
     //handleChangeVariantsLang({ target: { id: languageType } });
     
     
     //console.log(Object.keys(filterTree[event.target.id]));
     //setLanguageType(lang=>"");
     //event.target.id
     /*
     if(event.target.id=="printed"&&languageType!=""){
        //tistenA verze.
        
       //je treba pri zemene typu pocitat s tim, ze digital nema select aka musime vedet id varianty produktu.
        let key = Object.keys(filterTree[variantType][event.target.id]);
        let id_arr = Object.keys(filterTree[variantType][event.target.id][key[0]]);
        let id_p = parseInt(id_arr[0]);
        let objects = filterTree[variantType][event.target.id][key[0]][id_p];
        console.log(objects);
        setLimit(limit=>objects.stock_amount);
        setPrice(objects.price);
        setSelectedItemId(id_p);
    }
*/
    }

    const handleChangeVariantsLang = (event: any) => {
        setLanguageType(old=>event.target.id)
    
        //check if digital/printed -> render select or nothing (but still need id)
        if(variantType=="digital"){
            //digi verze
            let key = Object.keys(filterTree[variantType][event.target.id]);
            let id_arr = Object.keys(filterTree[variantType][event.target.id][key[0]]);
            let id_p = parseInt(id_arr[0]);
            let objects = filterTree[variantType][event.target.id][key[0]][id_p];
            
            setLimit(limit=>999);
            setPrice(objects.price);
            setSelectedItemId(id_p);

        }else if(variantType=="printed"){
            //tistenA verze.
            
            //console.log("kek");
            let key = Object.keys(filterTree[variantType][event.target.id]);
            let id_arr = Object.keys(filterTree[variantType][event.target.id][key[0]]);
            let id_p = parseInt(id_arr[0]);
            let objects = filterTree[variantType][event.target.id][key[0]][id_p];
            console.log(objects);
            setLimit(limit=>objects.stock_amount === -1 ? 9999 : objects.stock_amount);
            setPrice(objects.price);
            setSelectedItemId(id_p);
        }
      

           //setCheckVariantsLang({variantsLang: event.target.id, isChecked: true, items: pDetailData.variants.filter((variant) => variant.language == event.target.id)});
           //setCheckVariantsLang({variantsLang: event.target.id, isChecked: true, items: checkVariantsType.listItems.filter((variant) => variant.language == event.target.id)});
       // console.log(event.target.id, "CHECK VARIANTS LANG");
       // console.log(checkVariantsType.listItems, "NON-FILTERED LANG");
       // const filteredLang = checkVariantsType.listItems.filter((variant) => variant.language == event.target.id)
       // console.log(filteredLang, "FILTERED LANG");

   }
  // Use Effect to trigger the initial selection logic for the variant type

  useEffect(() => {

    if (pDetailData.variants.length > 0) {
        //console.log("help");
        const defaultVariant = pDetailData.variants[0];

        setVariantType(defaultVariant.type);
        if (variantType && Object.keys(filterTree[variantType]).length > 0) {
            //console.log("help");
            const defaultLanguage = Object.keys(filterTree[variantType])[0];
    
            //setLanguageType(defaultLanguage);
    
            handleChangeVariantsLang({ target: { id: defaultLanguage } });
    
        }
       

    }

}, [filterTree]);



// Use Effect to trigger the initial selection logic for the language type

useEffect(() => {

    if (variantType && Object.keys(filterTree[variantType]).length > 0) {
        //console.log("help");
        const defaultLanguage = Object.keys(filterTree[variantType])[0];
        if(languageType===""){
            handleChangeVariantsLang({ target: { id: defaultLanguage } });
        }else{
            handleChangeVariantsLang({ target: { id: languageType } });
        }
        //setLanguageType(defaultLanguage);
        console.log(languageType);


    }

}, [variantType]);



useEffect(()=>{
    const productVariants: ProductVariant[] = pDetailData.variants;
    const filterTree = createFilterTree(productVariants);
    //console.log("!!!!!!!!!!!!!!",filterTree);
    //console.log(Object.keys(filterTree));
    const typeKeys = Object.keys(filterTree);
    //const languageKeys = selectedType ? Object.keys(filterTree[selectedType] || {}) : [];
    if (productVariants.length === 0){
        // stock_amount -1 = neomezený sklad (digitální produkt)
        setLimit(pDetailData.stock_amount === -1 ? 9999 : pDetailData.stock_amount);
        // Produkt bez variant nemá co vybírat → cena se z varianty nikdy nenastaví.
        // Vezmeme efektivní cenu produktu (zohledňuje aktivní akci), jinak `price`
        // zůstane 0, aktuální cena se nevykreslí (render: `price !== 0`) a zobrazí
        // se jen přeškrtnutá cena.
        setPrice(pDetailData.effective_price ?? pDetailData.price);
    }
    setFilterTree(filterTree);
   // setVariantType("digital");
   // setLanguageType("Czech - čeština");
},[]);

const handleSelectChange = (event: { target: { value: string; }; }) => {
    const selectedValue = event.target.value;
    //console.log();
    //files: "/strihy/2020005657.pdf"
    //price: 79
    //stock_amount: 20
    //vat: 1
    let id_arr = Object.keys(filterTree[variantType][languageType][selectedValue]);
    let id_p = parseInt(id_arr[0]);
    let objects = filterTree[variantType][languageType][selectedValue][id_p];
    //console.log("___________________________________________________________");
    if (variantType==="digital"){
        setLimit(limit=>9999);

    }else{
        setLimit(limit=>objects.stock_amount === -1 ? 9999 : objects.stock_amount);

    }
    setPrice(objects.price);
    setSelectedItemId(id_p);

    //console.log(objects);
    //console.log("Selected value:", selectedValue);
    // You can call another function here and pass the selectedValue
};
    
/*
    const onChangeSelect = (event: any) => {
        // console.log(event, "SELECTBOX EVENT");
        const idSelected = event.target.value;
        console.log(idSelected, "ID SELECTED");
        const filteredItem = pDetailData.variants.filter((variant: any) => variant.id == idSelected);
        // console.log(filteredItem, "FILTERED ITEM IN SELECT HANDLER");

        // if (idSelected == filteredItem[0].id) {
            setItemPrice(filteredItem[0].price)
        // };
        setIdVariant(idSelected);
        setLimit(filteredItem[0].stock_amount);
    };
*/
/*

    const handleItemPrice = () => {
        if (pDetailData.variants.length > 0 && checkVariantsLang.isChecked == false) {
            setItemPrice(0);
            setItemOldPrice(0);
        }
        if (pDetailData.variants.length > 0 && dataVariantsType[0].type == "digital" && dataVariantsLang.length == 1) {
            setItemPrice(dataVariantSize[0].price);
            setIdVariant(dataVariantSize[0].id);
            setLimit(dataVariantSize[0].stock_amount);
        }
        // setItemPrice(pDetailData.price)
        // setItemPrice(checkVariantsLang.items[0].price)

        // if (checkVariantsType.variantsType == "printed") {
            if (checkVariantsLang.isChecked == true) {
console.log("error");
            
            }
     
    }
*/
    const decrease = () => {
        setItemCount(Math.max(itemCount - 1, 1));
    };
    const increase = () => {
        itemCount < limit ? setItemCount(itemCount + 1) : setItemCount(itemCount);
        if(itemCount == limit)  setTooltipVisible(prevState => ({
            ...prevState,tooltipClass: " tooltip-visible", tooltipSpan: true
    }));
};

    const showTooltip = (result: {status: boolean, message: string}) => {
        if (result.status){
            setFailMessage("");
            setTooltipVisible(prevState => ({...prevState,tooltipClass: " tooltip-visible",  tooltipAddToCartSpan: true}))
        }else{
            setFailMessage(result.message || "Nepodařilo se přidat do košíku.");
            setTooltipVisible(prevState => ({...prevState,tooltipClass: " tooltip-visible",  tooltipAddToCartFailedSpan: true}))
        }
    };

    const getTimeoutFunction = () => {
        const timer = setTimeout(() => {
            setTooltipVisible(prevState => ({...prevState,tooltipClass: "",tooltipSpan: false, tooltipAddToCartSpan: false,tooltipAddToCartFailedSpan: false }) );
          }, 5000);
          return () => clearTimeout(timer);
    }

    

    // console.log(pDetailData.variants, "Varianty");
    // console.log(checkVariantsType.variantsType, "Zvolená varianta");
    // console.log(checkVariantsType.variantsType == "digital", "Zvolená varianta DIGITAL");
    // console.log(checkVariantsLang, "CHECK VARIANTS LANG");
    // console.log(checkVariantsLang.isChecked == true, "CHECK VARIANTS LANG IS CHECKED");
    // console.log(checkVariantsLang.variantsLang, "Zvolený jazyk varianty");
    // console.log(checkVariantsType.items, "Vyfiltrované položky dle typu");
    // console.log(checkVariantsLang.items[0], "Vyfiltrované položky dle jazyka");
    // console.log(checkVariantsLang.items.filter((variant, index) => {checkVariantsType.items.indexOf(variant) === index}), "Vyfiltrované položky bez duplicit");
    // console.log(checkVariantsLang.items, "ITEMS LANG");
    // console.log(idVariant, "ID VARIANT");
    // console.log(itemCount, "ITEM COUNT");
    // console.log(limit, "STOCK AMOUNT");

const categoryRedirect = (categoryId: number) => {
    navigate(`/product?sort=price&search_query=&page=1&category=${categoryId}`);
}

// Cena: aktuální = stav `price` (varianta / efektivní cena produktu).
// Škrtnutá = u aktivní akce běžná cena (striked_price), jinak price_old.
// Procentuální sleva se počítá z reálně zobrazené aktuální ceny vůči škrtnuté.
const strikedPrice =
    pDetailData.has_action
        ? (pDetailData.striked_price ?? 0)
        : (pDetailData.old_price ?? 0);
const discountPct =
    strikedPrice > 0 && price > 0 && price < strikedPrice
        ? Math.round((1 - price / strikedPrice) * 100)
        : 0;


return (
    <div  className="inner">

{
//vrchni panel kategorie
pDetailData.parameters.category ? (
        <ul className="breadcrumbs">
          {pDetailData.parameters.category.map((categoryItem) => (
            <li key={categoryItem.id}>
              <a
                href={`/product?sort=price&search_query=&page=1&category=${categoryItem.id}`}
                data-name={categoryItem.type}
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.preventDefault();
                  categoryRedirect(categoryItem.id);
                }}
              >
                {categoryItem.name}
              </a>
            </li>
          ))}
        </ul>
      ) : null}
              <h2>{pDetailData.name}</h2>

              {pDetailData.parameters.manufacturer ? (
        <>
          {
          //vrchni panel vyrobce.
          pDetailData.parameters.manufacturer.map((manufacturerItem) => (
            <React.Fragment key={manufacturerItem.id}>
              {manufacturerItem.image ? (
                <>
                  <a className="ic_logo desktop" onClick={handleParams}>
                    <img
                      src={manufacturerItem.image}
                      onLoad={() => console.log('Ikona výrobce se načetla')}
                      onError={() => console.log('Ikona výrobce se nenačetla')}
                      alt={manufacturerItem.name}
                      data-id={manufacturerItem.id.toString()} 
                      data-name={manufacturerItem.type} 
                    />
                  </a>
                  <a className="ic_logo mobile" onClick={handleParams}>
                    <img
                      src={manufacturerItem.image}
                      onLoad={() => console.log('Ikona výrobce se načetla')}
                      onError={() => console.log('Ikona výrobce se nenačetla')}
                      alt={manufacturerItem.name}
                      data-id={manufacturerItem.id.toString()} 
                      data-name={manufacturerItem.type} 
                    />
                  </a>
                </>
              ) : null}
            </React.Fragment>
          ))}
        </>
      ) : null}

      {/* Statická specifikace produktu (Velikost / Materiál / Silueta / Další vlastnosti) */}
      {(() => {
        const p: any = pDetailData.parameters || {};
        const join = (arr: any[]) => (arr || []).map((x: any) => x?.name).filter(Boolean).join(", ");
        const rows = [
          { label: "Velikost", value: join(p.size) },
          { label: "Materiál", value: join(p.material) },
          { label: "Silueta", value: join(p.siluet || p.silueta) },
          { label: "Další vlastnosti", value: join(p.another) },
        ].filter((r) => r.value);
        return rows.length ? (
          <ul className="pd-specs">
            {rows.map((r) => (
              <li key={r.label}><strong>{r.label}:</strong> {r.value}</li>
            ))}
          </ul>
        ) : null;
      })()}

                {

                Object.keys(filterTree).length > 1 ?
                <label className="checkmark-variants">Typ střihu:
                    <ul className="filter-variants">
                        {pDetailData.variants
                            .filter((obj, index) => {return index === pDetailData.variants.findIndex(o => obj.type === o.type)})
                            .map((variant, index) => {
                                return (
                                    <li className="checkbox" key={variant.id}>
                                        <input type="radio" name="variants" id={variant.type} onChange={handleChangeVariantsType}  
                                        defaultChecked={index === 0}
                                        
                                        />
                                        <label className="checkmark" htmlFor={variant.type}>
                                            <span className="circle"></span>
                                            <span className="name">{variant.type == "digital" ? "Elektronická verze" : "Tištěný střih"}</span>
                                        </label>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </label>
            : null }

    {
variantType !== "" ? (
    <>
{
  
Object.keys(filterTree[variantType]).length > 1? 
                        <>
                            <label className="checkmark-variants">Jazyk:
                                <ul className="filter-variants">
                                    {Object.keys(filterTree[variantType])
                                        .map((variant, index) => {
                                            return (
                                                <li className="checkbox" key={variant}>
                                                    <input type="radio" name="language" id={variant} 
                                                        onChange={handleChangeVariantsLang}
                                                        defaultChecked={index === 0}
                                                    />
                                                    <label className="checkmark" htmlFor={variant}>
                                                        <span className="circle"></span>
                                                        <span className="name">{variant}</span>
                                                    </label>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </label>
                       
                        </>
                    : null
                                 }
</>): null }



{
                
                Object.keys(filterTree).length === 1 ?
                <label className="checkmark-variants">Typ střihu:
                    <ul className="filter-variants">
                        {pDetailData.variants
                            .filter((obj, index) => {return index === pDetailData.variants.findIndex(o => obj.type === o.type)})
                            .map((variant,index) => {
                                return (
                                    <li className="checkbox" key={variant.id}>
                                        <input type="radio" name="variants" id={variant.type} onChange={handleChangeVariantsType}
                                        defaultChecked={index === 0}
                                        />
                                        <label className="checkmark" htmlFor={variant.type}>
                                            <span className="circle"></span>
                                            <span className="name">{variant.type == "digital" ? "Elektronická verze" : "Tištěný střih"}</span>
                                        </label>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </label>
            : null }
{
variantType !== "" ? (
    <>
{
  
Object.keys(filterTree[variantType]).length === 1? 
                        <>
                            <label className="checkmark-variants">Jazyk:
                                <ul className="filter-variants">
                                    {Object.keys(filterTree[variantType])
                                        .map((variant,index) => {
                                            return (
                                                <li className="checkbox" key={variant}>
                                                    <input type="radio" name="language" id={variant} 
                                                        onChange={handleChangeVariantsLang}
                                                        defaultChecked={index === 0}
                                                    />
                                                    <label className="checkmark" htmlFor={variant}>
                                                        <span className="circle"></span>
                                                        <span className="name">{variant}</span>
                                                    </label>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </label>
                       
                        </>
                    : null
                                 }
</>): null }


                {/*
                 Object.keys(filterTree).length === 1 ?
                <>
                
                    <label className="checkmark-variants">Typ střihu:
                        <ul className="filter-variants">
                            {Object.keys(filterTree)
                                // .filter((obj, index) => {return index === pDetailData.variants.findIndex(o => obj.type === o.type)})
                                .map((variant) => {
                                    return (
                                        <li className="checkbox">
                                            <input type="radio" name="variants" id={variant} 
                                                // onChange={handleChangeVariants} 
                                                checked={true} 
                                            />
                                            <label className="checkmark" htmlFor={variant}>
                                                <span className="circle"></span>
                                                <span className="name">{variant == "digital" ? "Elektronická verze" : "Tištěný střih"}</span>
                                            </label>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </label>
                    { Object.keys(filterTree).length == 1 ?
                        <>         
                            <label className="checkmark-variants">Jazyk:
                                <ul className="filter-variants">
                                    {dataVariantsLang
                                        // .filter((obj, index) => {return index === pDetailData.variants.findIndex(o => obj.language === o.language)})
                                        .map((variant) => {
                                            return (
                                                <li className="checkbox">
                                                    <input type="radio" name="language" id={variant.language} 
                                                        // onChange={handleChangeVariantsLang}
                                                        checked={true}
                                                    />
                                                    <label className="checkmark" htmlFor={variant.language}>
                                                        <span className="circle"></span>
                                                        <span className="name">{variant.language}</span>
                                                    </label>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </label>
                            { dataVariantsType[0].type == "digital" ?
                                <label className="checkmark-variants">Velikosti:
                                    <select name="selected-size" 
                                    onChange={(e)=>{console.log("o")}}
                                    >
                                        {pDetailData.variants
                                            .filter((obj, index) => {return index === pDetailData.variants.findIndex(o => obj.size === o.size)})
                                            .map((variant) => <option value={variant.id}>{variant.size}</option>)
                                        }
                                    </select>
                                </label>
                            : null }
                            <div>haloooooo</div>
                        </>
                        
                    : Object.keys(filterTree[variantType]).length > 1 ? 
                        <>
                        <div>KURVAAAAAAA</div>
                            <label className="checkmark-variants">Jazyk:
                                <ul className="filter-variants">
                                    {Object.keys(filterTree[variantType])
                                        .map((variant) => {
                                            return (
                                                <li className="checkbox">
                                                    <input type="radio" name="language" id={variant} 
                                                        onChange={()=>{console.log("handlelang")}}
                                                    />
                                                    <label className="checkmark" htmlFor={variant}>
                                                        <span className="circle"></span>
                                                        <span className="name">{variant}</span>
                                                    </label>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </label>
                       
                        </>
                    : null }
                </>

            : dataVariantsType.length > 1 ?
                <label className="checkmark-variants">Typ střihu:
                    <ul className="filter-variants">
                        {Object.keys(filterTree)
                            .map((variant) => {
                                return (
                                    <li className="checkbox">
                                        <input type="radio" name="variants" id={variant}
                                         onChange={handleChangeVariants} />
                                        <label className="checkmark" htmlFor={variant}>
                                            <span className="circle"></span>
                                            <span className="name">{variant == "digital" ? "Elektronická verze" : "Tištěný střih"}</span>
                                        </label>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </label>
                    : null */}























{
//SELECT VELIKOSTI pro digital i printed varianty
    variantType !== "" && languageType !== "" && filterTree[variantType] && filterTree[variantType][languageType] ? (
        <>
            {Object.keys(filterTree[variantType][languageType]).filter(k => k !== "null").length > 0 ?
                <label className="checkmark-variants">Velikost:
                    <select name="selected-size" onChange={handleSelectChange}>
                        {Object.keys(filterTree[variantType][languageType])
                            .filter(k => k !== "null")
                            .map((variant) => <option key={variant} value={variant}>{variant}</option>)
                        }
                    </select>
                </label>
                : null
            }
        </>
    ) : null
}



<p>
    <>
    { /*
                {pDetailData.parameters.size ? <span><strong>Velikost: </strong>{pDetailData.parameters.size[0].name}<br /></span> : null}
                {pDetailData.parameters.material ? <span><strong>Materiál: </strong>{pDetailData.parameters.material[0].name}<br /></span> : null}
                {pDetailData.parameters.siluet ? <span><strong>Silueta: </strong>{pDetailData.parameters.siluet[0].name}<br /></span> : null}
                {pDetailData.parameters.another ? <span><strong>Další vlastnosti: </strong>{pDetailData.parameters.another[0].name}<br /></span> : null}
        */        
    }
                </>

            </p>

            <div className="clear"></div>

            <div className="amount">
                {
                price !== 0 ? <span className="price">{price} Kč</span> : null
                }
                {
                strikedPrice > 0 && strikedPrice > price
                    ? <span className="strikethrough">{strikedPrice} Kč</span>
                    : null
                }
                {
                discountPct > 0
                    ? <span className="discount-badge">−{discountPct} %</span>
                    : null
                }
            </div>

            {
            pDetailData.has_action && pDetailData.action_price_to
                ? <ActionCountdown until={pDetailData.action_price_to} />
                : null
            }

            <div className="clear"></div>

            {
            
            limit <= 0 ? 
            //NENÍ SKLADEM OPTION
            <div className="add-to-cart-block">
                <div className="count large">
                    <button className="btn-count disabled" type="button" disabled>
                        <span className="minus disabled"></span>
                    </button>
                    <input type="text" value="0" disabled />
                    <button className="btn-count disabled" type="button" disabled>
                        <span className="plus disabled"></span>
                    </button>
                </div>
                <button className="ic_cart desktop disabled" disabled>Není skladem</button>
                <button className="ic_cart inline mobile disabled" disabled>Není skladem</button>
            </div>
           // : Object.keys(filterTree).length > 0 && languageType == "" && variantType !== "" && Object.keys(filterTree[variantType]).length > 1 ?
           : 
           Object.keys(filterTree).length > 0 && languageType == ""
           ?
           //VARIANTY NOT SELECTED YET
            <span className="tooltiptext select-variant">Vyberte prosím požadovanou variantu produktu</span>
            :   
            variantType == "digital" && languageType !== "" ?
            //PRODUKT BUTTONS DISABLED ALL
            <div className={"add-to-cart-block" + tooltipVisible.tooltipClass}>
              <div className="count large">
              <button className="btn-count disabled" type="button" disabled>
                        <span className="minus disabled"></span>
                    </button>
                    <input type="text" value="1" readOnly />
                    <button className="btn-count disabled" type="button" disabled>
                        <span className="plus disabled"></span>
                    </button>
                </div>
                   
                {tooltipVisible.tooltipSpan == true ? <span className="tooltiptext">Více kusů není skladem</span> : null}

                {tooltipVisible.tooltipAddToCartSpan == true ? <span className="tooltiptext tooltip-cart">Produkt byl vložen do košíku</span> : null}
                {tooltipVisible.tooltipAddToCartFailedSpan == true ? <span className="tooltiptext">{failMessage}</span> : null}
                <button className="ic_cart desktop" onClick={ async () => {
        const result = await handlerAddToCart(pDetailData.id, itemCount, selectedItemId);
        showTooltip(result);
        getTimeoutFunction();
    }
                    }
                     >Přidat do košíku</button>
                <button className="ic_cart inline mobile" onClick={ async () => {
        const result = await handlerAddToCart(pDetailData.id, itemCount, selectedItemId);
        showTooltip(result);
        getTimeoutFunction();
    }}>Do košíku</button>
            </div>
            : isDigitalByFormat ?
                        //digital (single piece only — download)
            <div className={"add-to-cart-block" + tooltipVisible.tooltipClass}>
                <div className="count large">
                    <button className="btn-count disabled" type="button" disabled>
                        <span className="minus disabled"></span>
                    </button>
                    <input type="text" value="1" readOnly />
                    <button className="btn-count disabled" type="button" disabled>
                        <span className="plus disabled"></span>
                    </button>
                </div>
                {tooltipVisible.tooltipAddToCartFailedSpan == true ? <span className="tooltiptext">{failMessage}</span> : null}
                {tooltipVisible.tooltipAddToCartSpan == true ? <span className="tooltiptext tooltip-cart">Produkt byl vložen do košíku</span> : null}
                <button className="ic_cart desktop" onClick={async () => {
        const result = await handlerAddToCart(pDetailData.id, 1, selectedItemId);
        showTooltip(result);
        getTimeoutFunction();
    }
                     }>Přidat do košíku</button>
                <button className="ic_cart inline mobile" onClick={ async () => {
        const result = await handlerAddToCart(pDetailData.id, 1, selectedItemId);
        showTooltip(result);
        getTimeoutFunction();
    }}>Do košíku</button>
            </div>
            :
                        //other cart
            <div className={"add-to-cart-block" + tooltipVisible.tooltipClass}>
                <div className="count large">
                    <button className="btn-count" type="button" onClick={() => decrease()}>
                        <span className="minus"></span>
                    </button>
                    <input type="text" value={itemCount} readOnly />
                    <button className="btn-count" type="button" onClick={() => increase()}>
                        <span className="plus"></span>
                    </button>
                </div>
                {tooltipVisible.tooltipSpan == true ? <span className="tooltiptext">Více kusů není skladem</span> : null}
                {tooltipVisible.tooltipAddToCartFailedSpan == true ? <span className="tooltiptext">{failMessage}</span> : null}
                {tooltipVisible.tooltipAddToCartSpan == true ? <span className="tooltiptext tooltip-cart">Produkt byl vložen do košíku</span> : null}
                <button className="ic_cart desktop" onClick={async () => {
        const result = await handlerAddToCart(pDetailData.id, itemCount, selectedItemId);
        showTooltip(result);
        getTimeoutFunction();
    }
                     }>Přidat do košíku</button>
                <button className="ic_cart inline mobile" onClick={ async () => {
        const result = await handlerAddToCart(pDetailData.id, itemCount, selectedItemId);
        showTooltip(result);
        getTimeoutFunction();
    }}>Do košíku</button>
            </div>
            
            }
            {/*
            <ul className="tags">
                {
                
                pDetailData.parameters.for_whom ? 
                    <li>
                                {
                       //<a target={pDetailData.parameters.for_whom[0].id} name={pDetailData.parameters.for_whom[0].type} onClick={handleParams}>{pDetailData.parameters.for_whom[0].name}</a>
                }
                    </li> 
                    : null
                    
                    }
                {pDetailData.parameters.category ? 
                    <li>
                         {
                        //<a target={pDetailData.parameters.category[0].id} name={pDetailData.parameters.category[0].type} onClick={handleParams}>{pDetailData.parameters.category[0].name}</a>
                }
                    </li> 
                    : null}
                {pDetailData.parameters.difficulty ? 
                    pDetailData.parameters.difficulty.map((val) => {
                    return (
                        <li>
                            <a onClick={handlerClose}>{val}</a>
                        </li>
                    )
                }) : null}
            </ul>
*/
            }




        </div>

)};

/*
    return (
        <div  className="inner">
        

            <h2>{pDetailData.name}</h2>

            { pDetailData.parameters.manufacturer ? 
                <>
                    <a className="ic_logo desktop" onClick={handleParams}>
                        <img 
                            src={pDetailData.parameters.manufacturer[0].image}
                            onLoad={() => console.log('Ikona výrobce se načetla')} 
                            onError={() => console.log('Ikona výrobce se nenačetla')}
                            alt={pDetailData.parameters.manufacturer[0].name} 
                            id={pDetailData.parameters.manufacturer[0].id} data-name={pDetailData.parameters.manufacturer[0].type}
                        />
                    </a>
                    <a className="ic_logo mobile" onClick={handleParams}>
                        <img 
                            src={pDetailData.parameters.manufacturer[0].image}
                            onLoad={() => console.log('Ikona výrobce se načetla')} 
                            onError={() => console.log('Ikona výrobce se nenačetla')}
                            alt={pDetailData.parameters.manufacturer[0].name} 
                            id={pDetailData.parameters.manufacturer[0].id} data-name={pDetailData.parameters.manufacturer[0].type}
                        />
                    </a>
                </>
            : null }

            { dataVariantsType.length == 1 ?
                <>
                    <label className="checkmark-variants">Typ střihu:
                        <ul className="filter-variants">
                            {dataVariantsType
                                // .filter((obj, index) => {return index === pDetailData.variants.findIndex(o => obj.type === o.type)})
                                .map((variant: Variant) => {
                                    return (
                                        <li key={variant.id} className="checkbox">
                                            <input type="radio" name="variants" id={variant.type} 
                                                // onChange={handleChangeVariants} 
                                                checked={true}
                                            />
                                            <label className="checkmark" htmlFor={variant.type}>
                                                <span className="circle"></span>
                                                <span className="name">{variant.type == "digital" ? "Elektronická verze" : "Tištěný střih"}</span>
                                            </label>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </label>
                    { dataVariantsLang.length == 1 ?
                        <>         
                            <label className="checkmark-variants">Jazyk:
                                <ul className="filter-variants">
                                    {dataVariantsLang
                                        // .filter((obj, index) => {return index === pDetailData.variants.findIndex(o => obj.language === o.language)})
                                        .map((variant: Variant) => {
                                            return (
                                                <li key={variant.id} className="checkbox">
                                                    <input type="radio" name="language" id={variant.language} 
                                                        // onChange={handleChangeVariantsLang}
                                                        checked={true}
                                                    />
                                                    <label className="checkmark" htmlFor={variant.language}>
                                                        <span className="circle"></span>
                                                        <span className="name">{variant.language}</span>
                                                    </label>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </label>
                            { dataVariantsType[0].type == "digital" ?
                                <label className="checkmark-variants">Velikosti:
                                    <select name="selected-size" onChange={onChangeSelect}>
                                        {pDetailData.variants
                                            .filter((obj: any, index: any) => {return index === pDetailData.variants.findIndex((o: { size: any; }) => obj.size === o.size)})
                                            .map((variant: Variant) => <option value={variant.id}>{variant.size}</option>)
                                        }
                                    </select>
                                </label>
                            : null }
                        </>
                        
                    : dataVariantsLang.length > 1 ? 
                        <>
                            <label className="checkmark-variants">Jazyk:
                                <ul className="filter-variants">
                                    {dataVariantsLang
                                        // .filter((obj, index) => {return index === pDetailData.variants.findIndex(o => obj.language === o.language)})
                                        .map((variant: Variant) => {
                                            return (
                                                <li key={variant.id} className="checkbox">
                                                    <input type="radio" name="language" id={variant.language} 
                                                        onChange={handleChangeVariantsLang}
                                                    />
                                                    <label className="checkmark" htmlFor={variant.language}>
                                                        <span className="circle"></span>
                                                        <span className="name">{variant.language}</span>
                                                    </label>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </label>
                            {}
                        </>
                    : null }
                </>
            : dataVariantsType.length > 1 ?
                <label className="checkmark-variants">Typ střihu:
                    <ul className="filter-variants">
                        {pDetailData.variants
                            .filter((obj: any, index: any) => {return index === pDetailData.variants.findIndex((o: { type: any; }) => obj.type === o.type)})
                            .map((variant: Variant) => {
                                return (
                                    <li  key={variant.id}  className="checkbox">
                                        <input type="radio" name="variants" id={variant.type} onChange={handleChangeVariants} />
                                        <label className="checkmark" htmlFor={variant.type}>
                                            <span className="circle"></span>
                                            <span className="name">{variant.type == "digital" ? "Elektronická verze" : "Tištěný střih"}</span>
                                        </label>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </label>
            : null }

            {checkVariantsType.isChecked == true ? 
                <label className="checkmark-variants">Jazyk:
                    <ul className="filter-variants">
                        {checkVariantsType.items
                            .map((variant: Variant) => {
                                return (
                                    <li key={variant.id}  className="checkbox">
                                        <input type="radio" name="language" id={variant.language} onChange={handleChangeVariantsLang}/>
                                        <label className="checkmark" htmlFor={variant.language}>
                                            <span className="circle"></span>
                                            <span className="name">{variant.language}</span>
                                        </label>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </label>
            : null }
                
            {checkVariantsType.variantsType == "digital" || dataVariantsType.length == 1 && dataVariantsLang.length > 1 && dataVariantsType[0].type == "digital" ?
                checkVariantsLang.isChecked == true ? 
                    <label className="checkmark-variants">Velikosti:
                        <select name="selected-size" onChange={onChangeSelect}>
                            {checkVariantsLang.items
                                .filter((obj, index) => {return index === checkVariantsLang.items.findIndex(o => obj.size === o.size)})
                                .map((variant: Variant) => <option value={variant.id}>{variant.size}</option>)
                            }
                        </select>
                    </label>
                : null
            : null }

            <p>
                {pDetailData.parameters.size ? <span><strong>Velikost: </strong>{pDetailData.parameters.size[0].name}<br /></span> : null}
                {pDetailData.parameters.material ? <span><strong>Materiál: </strong>{pDetailData.parameters.material[0].name}<br /></span> : null}
                {pDetailData.parameters.siluet ? <span><strong>Silueta: </strong>{pDetailData.parameters.siluet[0].name}<br /></span> : null}
                {pDetailData.parameters.another ? <span><strong>Další vlastnosti: </strong>{pDetailData.parameters.another[0].name}<br /></span> : null}
            </p>

            <div className="clear"></div>

            <div className="amount">
                {!(itemPrice == 0) ? <span className="price">{itemPrice} Kč</span> : null}
                {!(itemOldPrice == 0 )|| !itemOldPrice == null ? <span className="strikethrough">{itemOldPrice} Kč</span> : null}
                {}
            </div>

            <div className="clear"></div>

            {limit <= 0 ? 
            <div className="add-to-cart-block">
                <div className="count large">
                    <button className="btn-count disabled" type="button" disabled>
                        <span className="minus disabled"></span>
                    </button>
                    <input type="text" value="0" disabled />
                    <button className="btn-count disabled" type="button" disabled>
                        <span className="plus disabled"></span>
                    </button>
                </div>
                <button className="ic_cart desktop disabled" disabled>Není skladem</button>
                <button className="ic_cart inline mobile disabled" disabled>Není skladem</button>
            </div>
            : pDetailData.variants.length > 0 && checkVariantsLang.isChecked == false && dataVariantsLang.length > 1 ?
            <span className="tooltiptext select-variant">Vyberte prosím požadovanou variantu produktu</span>
            : checkVariantsType.variantsType == "digital" && checkVariantsLang.isChecked == true ?
            <div className={"add-to-cart-block" + tooltipVisible.tooltipClass}>
                <div className="count large">
                    <button className="btn-count disabled" type="button" disabled>
                        <span className="minus disabled"></span>
                    </button>
                    <input type="text" value="1" />
                    <button className="btn-count disabled" type="button" disabled>
                        <span className="plus disabled"></span>
                    </button>
                </div>
                {tooltipVisible.tooltipSpan == true ? <span className="tooltiptext">Více kusů není skladem</span> : null}

                {tooltipVisible.tooltipAddToCartSpan == true ? <span className="tooltiptext tooltip-cart">Produkt byl vložen do košíku</span> : null}
                <button className="ic_cart desktop" onClick={() => {showTooltip(); getTimeoutFunction(); handlerAddToCart(pDetailData.id, 1, idVariant)}}>Přidat do košíku</button>
                <button className="ic_cart inline mobile" onClick={() => {showTooltip(); getTimeoutFunction(); handlerAddToCart(pDetailData.id, 1, idVariant)}}>Do košíku</button>
            </div>
            :
            <div className={"add-to-cart-block" + tooltipVisible.tooltipClass}>
                <div className="count large">
                    <button className="btn-count" type="button" onClick={() => decrease()}>
                        <span className="minus"></span>
                    </button>
                    <input type="text"  defaultValue={itemCount} />
                    <button className="btn-count" type="button" onClick={() => increase()}>
                        <span className="plus"></span>
                    </button>
                </div>
                {tooltipVisible.tooltipSpan == true ? <span className="tooltiptext">Více kusů není skladem</span> : null}

                {tooltipVisible.tooltipAddToCartSpan == true ? <span className="tooltiptext tooltip-cart">Produkt byl vložen do košíku</span> : null}
                <button className="ic_cart desktop" onClick={() => {showTooltip(); getTimeoutFunction(); handlerAddToCart(pDetailData.id, itemCount, idVariant)}}>Přidat do košíku</button>
                <button className="ic_cart inline mobile" onClick={() => {showTooltip(); getTimeoutFunction(); handlerAddToCart(pDetailData.id, itemCount, idVariant)}}>Do košíku</button>
            </div>
            }

            <ul className="tags">
                {pDetailData.parameters.for_whom ? 
                    <li key={pDetailData.parameters.for_whom[0].id} >
                        <a target={pDetailData.parameters.for_whom[0].id} data-name={pDetailData.parameters.for_whom[0].type} onClick={handleParams}>{pDetailData.parameters.for_whom[0].name}</a>
                    </li> 
                    : null}
                {pDetailData.parameters.category ? 
                    <li key={pDetailData.parameters.category[0].id}>
                        <a target={pDetailData.parameters.category[0].id} data-name={pDetailData.parameters.category[0].type} onClick={handleParams}>{pDetailData.parameters.category[0].name}</a>
                    </li> 
                    : null}
                {pDetailData.parameters.difficulty ? 
                    pDetailData.parameters.difficulty.map((val: any) => {
                    return (
                        <li key={val.id}>
                            <a onClick={handlerClose}>{val.name}</a>
                        </li>
                    )
                }) : null}
            </ul>
        </div>
    )
}
*/
export default ProductDetailLabels;